export default {
  name: 'ProductList',

  props: {
    value: Array,
    customerGroupId: Number,
    discountedPriceFormula: Function,
    enableSubsidy: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    getDiscountedPrice (product) {
      return this.discountedPriceFormula(this.getBasePrice(product))
    },

    getBasePrice (product) {
      return this.customerGroupId === 0 ? product.regularPrice : product.regularCustomerGroupPrice
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/ViewEvent/ViewPromotion/ProductList.js